import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctString } from '../../../../Fct/generics';
export var Name = createPlugin({
    protocol: 'ERC721',
    type: 'GETTER',
    method: 'name',
    supportedContracts: undefined,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'erc721' }),
                methodParams: {},
            },
            output: {
                undefined: new FctString({ innerIndex: 0 }),
            },
        });
    },
});
